import utilReducer from "./utilReducer";

const utilReducers = {
    util: utilReducer
}

export default utilReducers